import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from '../ui/Button';
const navItems = [{
  label: 'Opportunities',
  to: '/opportunities'
}, {
  label: 'For Employers',
  to: '/employers'
}, {
  label: 'Your Firm',
  to: '/firm'
}, {
  label: 'Insights',
  to: '/insights'
}, {
  label: 'Dashboards',
  to: '/dashboard'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className={`sticky top-0 z-50 transition-all duration-500 ${scrolled ? 'bg-ivory-100/90 backdrop-blur-md border-b border-ink/10 shadow-soft' : 'bg-transparent border-b border-transparent'}`} data-id="element-256" data-mp="3uh64qiemlf0u">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10" data-id="element-257" data-mp="bsx8s5fkrl9t">
        <Link to="/" className="group flex items-center gap-3" aria-label="Ardent home" data-id="element-258" data-mp="gm9vga0p1hzx">
          <span className="flex h-9 w-9 items-center justify-center rounded-full border border-gold text-gold-dark" data-id="element-259" data-mp="lk1lszloww20">
            <span className="font-serif text-lg leading-none" data-id="element-260" data-mp="3k4b94zsudmy0">A</span>
          </span>
          <span className="flex flex-col leading-none" data-id="element-261" data-mp="3p1ti2q6v0260">
            <span className="font-serif text-lg tracking-wide text-ink" data-id="element-262" data-mp="3tzv1xdc405ij">Ardent</span>
            <span className="text-[10px] uppercase tracking-widest2 text-ink-500" data-id="element-263" data-mp="1wc27fnwq23v">
              Executive Search
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary" data-id="element-264" data-mp="199w07llnqsod">
          {navItems.map(item => <NavLink key={item.to} to={item.to} className={({
          isActive
        }) => `relative text-sm tracking-wide transition-colors ${isActive ? 'text-ink' : 'text-ink-600 hover:text-ink'} after:absolute after:-bottom-1.5 after:left-0 after:h-px after:bg-gold after:transition-all after:duration-300 ${isActive ? 'after:w-full' : 'after:w-0 hover:after:w-full'}`} data-id="element-265" data-mp="1ddlla134is4n">
              {item.label}
            </NavLink>)}
        </nav>

        <div className="hidden items-center gap-3 lg:flex" data-id="element-266" data-mp="2mkzgp0ipxs8m">
          <Button to="/opportunities" variant="ghost" size="sm" data-id="element-267" data-mp="30ez70bvp11kt">
            Sign in
          </Button>
          <Button to="/employers" variant="primary" size="sm" data-id="element-268" data-mp="2vmpaue3zj5a3">
            Engage us
          </Button>
        </div>

        <button className="flex h-10 w-10 items-center justify-center rounded-full text-ink lg:hidden" onClick={() => setOpen(o => !o)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-269" data-mp="27w3ehk3cf9fx">
          {open ? <XIcon className="h-5 w-5" data-id="element-270" data-mp="n8j0rpvo9ag4" /> : <MenuIcon className="h-5 w-5" data-id="element-271" data-mp="n8siyrah6db9" />}
        </button>
      </div>

      {open && <div className="border-t border-ink/10 bg-ivory-100 lg:hidden" data-id="element-272" data-mp="9hnpy81m4j9w">
          <nav className="flex flex-col px-6 py-4" aria-label="Mobile" data-id="element-273" data-mp="eg8qk8ks14yv">
            {navItems.map(item => <NavLink key={item.to} to={item.to} className={({
          isActive
        }) => `border-b border-ink/5 py-3 text-sm ${isActive ? 'text-ink' : 'text-ink-600'}`} data-id="element-274" data-mp="12630oidpofff">
                {item.label}
              </NavLink>)}
            <div className="mt-4 flex flex-col gap-3" data-id="element-275" data-mp="3cw9xwllz8rj8">
              <Button to="/opportunities" variant="outline" size="md" data-id="element-276" data-mp="3cvi1j8kk2prw">
                Sign in
              </Button>
              <Button to="/employers" variant="primary" size="md" data-id="element-277" data-mp="3htjlrwtpwv4y">
                Engage us
              </Button>
            </div>
          </nav>
        </div>}
    </header>;
}